import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "动漫资讯", to: "/news" },
  { label: "动漫作品", to: "/works" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-leaf-fill text-lg"></i>
            </span>
            <span className="font-logo text-2xl text-foreground-950 leading-none pt-1">
              漫蛙官网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "text-primary-700 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/search"
              className="flex items-center gap-2 px-3 h-9 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-500 hover:border-primary-300 cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索动漫…</span>
            </Link>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-3 text-sm rounded-md whitespace-nowrap cursor-pointer ${
                  isActive(item.to)
                    ? "text-primary-700 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}